import React, { useState, useEffect } from 'react';

import * as S from './style';
const Interruptor = ({ value, onChange, disabled }) => {

    const [isOn, setIsOn] = useState(value);

    useEffect(() => {
        if (value !== isOn) {
            setIsOn(value);
        }
    }, [value]);

    const changeIsOn = (e) => {
        e.stopPropagation();
        if (disabled) return;
        const next = !isOn;
        setIsOn(next);
        onChange(next);
    };

    return (
        <S.ContainerSwitch onClick={changeIsOn}>
            <S.SwitchContainer isOn={isOn}>
                <S.SwitchCircle isOn={isOn} />
            </S.SwitchContainer>
        </S.ContainerSwitch>
    );
};

export default Interruptor;
